import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ContactsDialogConfirmContactDeleteComponent } from '../contact-confirm-delete-modal/contact-confirm-delete-modal.component';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

export interface NewContactDialogData {
    firstName?: string;
    lastName?: string;
    email: string;
    copyAlerts?: boolean;
    copyOrders?: boolean;
}

@Component({
    selector: 'app-systemcontacts-new-contact-modal',
    styleUrls: ['./systemcontacts-new-contact-modal.component.scss'],
    templateUrl: './systemcontacts-new-contact-modal.component.html',
})
export class SystemcontactsNewContactModalComponent implements OnInit {
    contactForm: UntypedFormGroup;

    // For AppDialogWrapperService pattern
    data: NewContactDialogData;
    dialogRef: { close: (result?: any) => void };

    constructor(
        private appDialogWrapperService: AppDialogWrapperService
    ) {}

    ngOnInit(): void {
        if (!this.data.email) {
            this.data.copyAlerts = true;
            this.data.copyOrders = true;
        }

        this.contactForm = new UntypedFormGroup({
            copyAlerts: new UntypedFormControl(this.data.copyAlerts),
            copyOrders: new UntypedFormControl(this.data.copyOrders),
            email: new UntypedFormControl(this.data.email, [
                Validators.required,
                Validators.email,
            ]),
            firstName: new UntypedFormControl(this.data.firstName),
            lastName: new UntypedFormControl(this.data.lastName),
        });
    }

    // Public Methods
    public onSave(): void {
        if (this.contactForm.valid) {
            const result: NewContactDialogData = {
                ...this.data,
                copyAlerts: this.contactForm.value.copyAlerts,
                copyOrders: this.contactForm.value.copyOrders,
                email: this.contactForm.value.email,
                firstName: this.contactForm.value.firstName,
                lastName: this.contactForm.value.lastName,
            };
            this.dialogRef.close(result);
        }
    }

    public onCancelClick(): void {
        this.dialogRef.close();
    }

    public confirmDelete(data: NewContactDialogData) {
        const dialogWrapper = this.appDialogWrapperService.open<any>({
            title: 'Delete Contact',
            component: ContactsDialogConfirmContactDeleteComponent,
            data: data,
            width: '450px'
        });

        dialogWrapper.afterClosed().subscribe((result) => {
            if (!result || result !== 'cancel') {
                this.dialogRef.close('delete');
            }
        });
    }
}
